import Link from "next/link";
import type { LucideIcon } from "lucide-react";

import { Button } from "@/components/ui/button";

interface EmptyStateAction {
  label: string;
  href?: string;
  onClick?: () => void;
}

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  action?: EmptyStateAction;
  blurColor?: "neutral-100" | "neutral-50";
  iconColor?: "text-neutral-300" | "text-neutral-200";
}

export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  blurColor = "neutral-100",
  iconColor = "text-neutral-300",
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center gap-6 text-center pt-32 pb-20">
      <div className="relative">
        <div className={`absolute -inset-4 bg-${blurColor} rounded-full blur-xl`} />
        <Icon className={`relative h-14 w-14 ${iconColor}`} strokeWidth={1} />
      </div>
      <div className="space-y-2">
        <p className="text-lg font-medium">{title}</p>
        {description && (
          <p className="text-sm text-muted-foreground max-w-[280px]">{description}</p>
        )}
      </div>
      {action &&
        (action.href ? (
          <Button variant="outline" size="sm" className="rounded-sm" asChild>
            <Link href={action.href}>{action.label}</Link>
          </Button>
        ) : (
          <Button variant="outline" size="sm" className="rounded-sm" onClick={action.onClick}>
            {action.label}
          </Button>
        ))}
    </div>
  );
}
